export default "<span class=\"page-title\">{{ (pageInfo$ | async).title | translate }}</span>\r\n";